<template>
  <div class="content-detail-wrap">
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        返回列表
      </div>
    </div>

    <div class="detail-container" v-if="currentContent">
      <h1 class="detail-title">{{ currentContent.title }}</h1>

      <div class="detail-meta" v-if="currentContent.meta">
        <span v-for="(meta, index) in currentContent.meta" :key="index">{{ meta }}</span>
      </div>

      <div class="detail-content" v-html="currentContent.content"></div>
    </div>

    <Footer />
  </div>
</template>

<script>
import { Footer } from '@/components'

function requireImg(str) {
  return require('pbimages/content/' + str)
}

const contentData = {
  1: {
    title: '律师自述 | 500起刑民交叉案件后，他总结出这套「零遗漏」日程管理法',
    meta: ['律师介绍 · 隋丛军', '山东咨文台律师事务所高级合伙人/案件云5年用户'],
    content: `
      <p><strong>执业领域：</strong>民商事争议解决/企业合规/经济犯罪辩护<br>
      <strong>执业年限：</strong>8年（2017年至今）<br>
      <strong>服务特色：</strong>复合型法律经验（6年涉外公司法务+8年律师执业）<br>
      <strong>执业成果：</strong>年均经手案件超150件，累计办理刑民交叉案件超500起</p>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">痛点：日程管理的三重困境</span>
      </div>

      <p>在隋丛军律师的职业生涯中，曾有过一次有惊无险的教训。回溯到五年前，彼时他正被堆积如山的案头工作所困，一次关键的疏忽，让两个案件的开庭日程险些完全重叠。虽然最终得以化解，但那个"差一点"的瞬间，让他下定决心终结这种被动状态，并由此开启了一场工作效率的革新。</p>

      <p>也正因如此，他开始寻找破局之法，并由此开启了他与「案件云」长达五年的并肩协作。</p>

      <ul>
        <li><strong>多个系统来回切换：</strong>他的日程散落在纸质台历、手机日历和微信聊天里。每天上班第一件事，就是像情报员一样在多个系统间来回核对，精神高度紧张，工作节奏总是被打乱，显得匆忙而被动。</li>
        <li><strong>"死线"前的恐惧：</strong>错过一个截止日期可能就是致命的执业事故。他常常在深夜突然惊醒，反复回想某个期限，这种源于"怕忘记"的焦虑，让他的工作状态难以从容。</li>
        <li><strong>临时安排的冲击：</strong>法官的临时通知、客户的紧急会见，都会轻易打乱他原本就脆弱的计划，让一切陷入更深的忙乱。</li>
      </ul>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">解决方案：案件云的四大核心功能</span>
      </div>

      <p>2021年在朋友的推荐下，隋律师开始使用"案件云"。</p>

      <p><strong>1. 化零为整，一屏尽览</strong></p>
      <p>他将所有案件的关键节点全部录入系统。现在，打开"案件云"的日历视图，他一周、一月的重要安排一目了然，终于能清晰地规划时间。</p>
      <img class="block-img" src="${requireImg('content1-1.webp')}" alt="" style="width: 100%;">
      <img class="block-img" src="${requireImg('content1-2.webp')}" alt="" style="width: 100%;">

      <p><strong>2. 主动防御，告别遗忘</strong></p>
      <p>系统成为了他最可靠的"守门员"。对于每一个关键节点，他都设置了提前提醒，确保他永远走在时间的前面，不再被动的追赶日程。</p>
      <img class="block-img" src="${requireImg('content1-3.webp')}" alt="" style="width: 100%;">

      <p><strong>3. 智能关联，日程有据</strong></p>
      <p>每一个日程都直接关联到对应的案件页面，随时可以快速浏览相关材料，让他面对任何日程都胸有成竹。</p>
      <img class="block-img" src="${requireImg('content1-4.webp')}" alt="" style="width: 100%;">
      <img class="block-img" src="${requireImg('content1-5.webp')}" alt="" style="width: 100%;">

      <p><strong>4. 多终端协调</strong></p>
      <p>案件云日程支持同步到第三方应用日历，对于使用电脑、平板、手机多设备协同工作帮助非常大，就能更加方便、高效地管理自己的日程，不用担心错漏任何一条事项。通过日历订阅，隋律师在案件云上设置的日程，可以同步到iPhone手机日历和Macbook电脑日历。而使用系统自由度更高的安卓手机可以设置自由度更高的桌面日程提醒。</p>
      <img class="block-img" src="${requireImg('content1-6.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">成果：工作状态的根本转变</span>
      </div>

      <p>隋律师的工作状态实现了根本性的转变。</p>
      <img class="block-img" src="${requireImg('content1-7.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>心态的转变：从焦虑到从容</strong>
        "我知道有个靠谱的'伙伴'在帮我守着所有底线。"关键日程遗漏的情况为0，带来的不仅是职业安全，更是内心的平静，让他能真正从容地应对每一天。
      </div>

      <div class="highlight-box">
        <strong>时间的解放：从被动到主动</strong>
        清晰的日程视图让他能提前规划整周的工作，将任务合理安排。他甚至能主动为自己安排出"思考时间"和"学习时间"，对工作节奏的掌控力大大增强。
      </div>

      <div class="highlight-box">
        <strong>专业的回归：聚焦核心价值</strong>
        当繁琐的日程记忆与核对工作被自动化后，他发现自己每天平均能多出近1.5小时。这些被释放出来的"黄金时间"，让他能更深入地研究案件、打磨文书。如今，在处理多个案件时，他显得游刃有余，再也不是那个疲于奔命的忙碌律师。
      </div>

      <p>对隋律师而言，"案件云"远不止是一个工具，它重构了他的工作流。通过实现对日程的绝对掌控，他将精力从繁琐的事务性追踪中解放出来，真正聚焦于法律专业本身，从而显著提升了其专业效能与工作质量。</p>
    `,
  },
  2: {
    title: '上海律杏信息科技有限公司加入上海法律科技协会',
    content: `
      <p>上海法律科技协会成立于2025年7月，以"深化科技在法律领域的应用，推动法律与科技良性互动、融合发展，提升法律服务智能化水平，助力上海法治建设"为服务宗旨，致力于开展法律科技政策宣传、调查研究、标准制定、信息交流，推动法律科技产品研发，提供业务培训，承接有关部门委托服务项目。</p>
      <img class="block-img" src="${requireImg('content2-1.webp')}" alt="" style="width: 100%;">
    `,
  },
  3: {
    title: '干货分享 | 律师如何躺收案源？设置好这个，让白嫖党自动退退退！',
    content: `
      <p>作为律师，就免不了被客户、被周围的亲朋好友以所谓"做人情"的方式白嫖，这已成为一种普遍且令人疲惫的行业现象。</p>

      <p>在法律行业，律师被客户"白嫖"——即客户通过各种方式获取免费法律咨询而不愿支付相应费用——已成为普遍存在的职业困境。这一现象不仅侵蚀律师的劳动价值，更影响法律服务的专业生态。</p>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">困境根源：价值错位与边界模糊</span>
      </div>

      <ul>
        <li><strong>客户认知偏差：</strong>普遍低估法律咨询背后的知识体系与判断力价值，误将专业服务等同于信息搜索。</li>
        <li><strong>行业环境催化：</strong>激烈竞争与部分平台"免费"噱头，助长了客户对无偿服务的期待。</li>
        <li><strong>律师自身因素：</strong>职业初期的生存焦虑与不善于管理客户预期，导致主动或被动地提供了过多免费劳动。</li>
      </ul>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">核心策略：构建"筛选-展示-转化"的全流程专业防线</span>
      </div>

      <p>破解困境的关键，在于将被动应付转为主动管理。律师需构建一套从初次接触到建立委托的全流程方法，其核心是：<strong>事先立规矩，事中展价值，事后有转化，全程靠心态</strong>。</p>

      <p><strong>第一步：建立清晰规则，前置筛选客户</strong></p>
      <p>在官网、社交资料等所有触点明确标注服务收费门槛（如"前15分钟仅作方向性指引"）。沟通伊始便友好而坚定地传递付费理念，利用低价知识产品（如风险提示清单）初步筛选出尊重专业价值的客户。</p>

      <p><strong>第二步：在过程中深度展示专业，而不仅是给答案</strong></p>
      <p>咨询时，重点展示分析逻辑、法律依据与类案经验，而非直接给出结论。让客户直观感受"信息"与"解决方案"的天壤之别，并自然理解后续持续服务的必要性。</p>

      <p><strong>第三步：设立心理边界，有尊严地拒绝</strong></p>
      <p>深刻认同自身智慧与时间的价值。对明显"白嫖"者，学会礼貌且坚定地说"不"。将精力集中于真正认可专业、愿意为解决方案付费的客户。</p>

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">借助AI数字名片塑造专业的价值形象</span>
      </div>

      <div class="highlight-box">
        <strong>内容营销建立专业权威</strong>
        使用案件云 lawEos AI 配置数字名片，展现过往的专业文章、精彩案例，塑造专业领域权威形象。当客户慕名而来时，他们更看重的是专业能力而非价格，更容易接受付费要求。
      </div>

      <div class="highlight-box">
        <strong>数字分身打造个人品牌</strong>
        使用案件云AI数字分身lawEos AI，您可以创建一个虚拟形象，这个"永不疲倦的律师助理"能够：基于对您专业领域、基本信息和常见咨询逻辑的学习，lawEos能代替你与客户进行专业、得体的初步交流，再也不用担心被客户"白嫖"了。
      </div>
      <img class="block-img" src="${requireImg('content3-1.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>7x24小时即时响应</strong>
        杜绝因忙碌而流失客户，秒级回应任何时区的咨询，极大提升客户体验。
      </div>
      <img class="block-img" src="${requireImg('content3-2.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>引导式提问</strong>
        通过多轮对话，初步厘清案件事实，梳理法律争议焦点，并提供基础的法律原则解释。
      </div>
      <img class="block-img" src="${requireImg('content3-3.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>标准化信息收集</strong>
        自动询问并结构化记录客户的核心信息（如姓名、地址、案情等），为您后续接洽做好充分准备。
      </div>
      <img class="block-img" src="${requireImg('content3-4.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>自动收集精准线索</strong>
        每一轮咨询结束后，自动生成包含客户画像、联系方式、案情摘要、核心诉求及初步法律判断的简报，让您在接触客户前已掌握全局。
      </div>
      <img class="block-img" src="${requireImg('content3-5.webp')}" alt="" style="width: 100%;">

      <p>律师被"白嫖"现象既源于外部环境，也与律师自身的经营策略密切相关。破解这一困境，需要律师重新定位自己的专业价值。</p>

      <p>借助像案件云智能体lawEos AI这样的AI数字名片与数字分身，律师能够高效地建立起专业的"价值防线"。它能让潜在客户在接触之初就充分感知到您的专业深度，从而将关注的焦点从"成本"转向"价值"。更重要的是，它能够作为一种温和而坚定的"边界设定工具"，通过智能互动提供标准信息、筛选有效需求，引导客户自然而然地进入付费咨询流程，从根本上减少"被白嫖"的机会。</p>
    `,
  },
  4: {
    title: '一位律师的六年深度使用笔记：我的"全天候律师助理"',
    meta: ['作者：陈尧鑫（广东省中山市执业律师）'],
    content: `
      <p><strong>执业背景：</strong><br>
      我于2018年踏入律师行业，2019年进入实习律师阶段，2020年正式执业至今。实习期间，因带教师父承办大量批量性系列案件，需反复进行机械性的文书录入与案件台账管理工作。为提升效率、保障工作质量，我先后试用了多款律师案件管理系统，最终选定"案件云"并沿用至今。</p>
      <img class="block-img" src="${requireImg('content4-1.webp')}" alt="" style="width: 100%;">

      <p>多年来，案件云始终紧跟诉讼政策动态持续优化升级，从多维度为律师日常工作提供精准辅助，成为我执业路上不可或缺的得力助手。</p>
      <img class="block-img" src="${requireImg('content4-2.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">文书高效生成，告别重复录入与差错</span>
      </div>

      <p>民商事诉讼律师日常需制作代理合同、授权委托书、所函、接案笔录、风险告知书等常规文书，还需适配各地法院要求的地址确认书、账户确认书等标准化文件。</p>

      <p>这类工作往往需要反复录入双方当事人信息，不仅耗时费力，还容易出现错别字等疏漏。</p>

      <p>案件云的文书模板功能彻底解决了这一痛点。通过系统字段参照表或自定义字段功能，可将当事人名称、联系方式、标的额等常用信息设置为固定字段代码。</p>
      <img class="block-img" src="${requireImg('content4-3.webp')}" alt="" style="width: 100%;">

      <p>只需将代码嵌入Word模板并上传至系统模板库，创建案件时填写并核对相关要素信息，即可从文书库一次性生成全套标准化文书。</p>

      <p>既大幅节省了文书制作时间，又有效避免了信息录入错误，是我使用频率最高也最为青睐的功能。</p>
      <img class="block-img" src="${requireImg('content4-4.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">云日程多端同步，行程提醒万无一失</span>
      </div>

      <p>对诉讼律师而言，"忘记开庭"时间是严重的工作失误，可能给委托人造成重大经济损失。</p>

      <p>相较于传统纸质日历或手机自带日历的登记方式，案件云的云日程表更贴合律师工作需求。</p>
      <img class="block-img" src="${requireImg('content4-5.webp')}" alt="" style="width: 100%;">

      <p>该功能实现了网页端、微信小程序、手机APP的数据实时共享，收到开庭传票后，可直接在系统内登记开庭时间、法院法庭、案件关联等详情。</p>

      <p>同时，可根据实际需求灵活设置提前提醒时间，从提前10分钟到提前2天不等，系统会通过微信及时推送提醒，确保无论身处何地、使用何种设备，都能随时查看行程，彻底杜绝遗漏开庭或重要工作安排的情况。</p>
      <img class="block-img" src="${requireImg('content4-6.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">财产保全精准管理，续封提醒规避脱保风险</span>
      </div>

      <p>以珠三角地区为例，基层法院办案压力巨大，法官人均未结案件量已达650-700件，案件审理周期常超出财产保全期限，需及时向法院申请续封直至案件办结。</p>
      <img class="block-img" src="${requireImg('content4-7.png')}" alt="" style="width: 100%;">

      <p>根据法律规定，银行存款冻结期限为一年，动产查封期限为两年，不动产查封期限为三年，不同类型财产的保全要求各不相同。</p>

      <p>律师手头案件类型繁杂、所处阶段各异，若未能妥善管理保全情况，极易出现"脱保"问题。</p>

      <p>案件云的财产保全管理功能可精准应对这一需求，支持登记关联案件、申请人与被申请人信息、财产类型、查封日期、保全金额等关键内容，还能通过AI智能表单填充功能简化信息录入。</p>

      <p>系统可自定义续封提醒时间，通过微信+邮箱双重渠道推送通知，确保律师及时办理续封手续，有效规避因脱保被当事人问责的风险。</p>
      <img class="block-img" src="${requireImg('content4-8.png')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">04</span>
        <span class="section-title">财务收支可视化，收费管理清晰透明</span>
      </div>

      <p>律师费是委托人选择律师服务的重要参考因素，律师行业常见一次性支付、分期付款、全风险提成、半风险提成等多种收费模式。面对大量案件时，仅凭记忆极易出现收费情况混淆、发票开具遗漏等问题。</p>
      <img class="block-img" src="${requireImg('content4-9.png')}" alt="" style="width: 100%;">

      <p>案件云的财务登记功能为律师提供了清晰的解决方案，可详细记录对应案件的律师费应收金额、已收金额、未收金额，以及发票开具状态等信息。通过可视化呈现方式，律师能快速掌握每起案件的财务收支情况，既方便与委托人核对账目，也为自身财务管理提供了精准数据支持，彻底告别"好记性不如烂笔头"的繁琐。</p>

      <div class="section-header">
        <span class="section-num">05</span>
        <span class="section-title">AI赋能要素状生成，告别繁琐填写，提速立案流程</span>
      </div>

      <p>2025年起，全国法院陆续推行「要素式起诉状」，这一举措虽规范了立案材料格式，但对法律从业者而言，要素状填写过程繁琐细碎，且部分模板设置未能完全贴合不同案件的实际需求，反而在一定程度上延缓了立案起诉的整体效率。</p>

      <p>案件云针对这一痛点，创新推出"传统诉状转要素状"的AI智能功能。无需手动逐一填写要素项，只需上传已有的传统格式起诉状，系统便能自动分析诉状中的核心信息，包括当事人身份、诉讼请求、事实与理由、证据指向等关键内容，进而自主匹配要素状的规范字段，完成信息填充。</p>

      <p>最终只需一键确认，即可生成符合法院要求的要素式起诉状，大幅减少了人工填写的时间成本与出错概率，让立案准备工作更高效顺畅。</p>
      <img class="block-img" src="${requireImg('content4-10.png')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>总结</strong>
        从实习律师到执业律师的数年时光里，案件云始终以"高效、精准、贴心"的特性，陪伴我应对批量案件文书处理、密集开庭行程、复杂财产保全管理等各类工作挑战。
      </div>

      <div class="highlight-box">
        <strong>未来期待</strong>
        未来，我期待案件云能持续迭代优化，比如进一步提升AI智能填充的精准度、拓展与法院系统的数据对接场景等。相信这款贴合律师实际需求的管理系统，会成为更多法律从业者提升工作效率、保障执业质量的得力伙伴，助力我们在专业道路上更高效、更从容地前行。
      </div>
    `,
  },
  5: {
    title: '做独立律师最怕的事情：忘记开庭',
    content: `
      <p>做独立律师之前，我每每看到这类帖子，都非常不屑。什么人会忘记开庭啊？？</p>

      <p>结果今年夏天，有天我在地铁上，送老妈回长沙，突然接到带区号的电话，一接通就问我："X律师，你怎么还没到庭？"</p>

      <p>我一瞬间皮都紧了，心想不对啊，这个庭我已经惦记很久了，应该是明天开庭才对，当时传票一发我就已经开始做准备了。</p>

      <p>后来一核对才发现，发传票当天正好在两个月交界，日期对周几，我一下子给对岔了，哪怕后面自己记得提醒自己多次，但一直是在记错误日期。</p>

      <p>好在后面没影响开庭，案件结果也挺好的。但开完庭一回家，我寻思不能愧给我们J人的称号，痛定思痛，我就买了份纸质挂历，这和我买机械闹钟一样的原理：电子的我能看错，我给整个实体的再加强下。</p>

      <div class="highlight-box">
        <strong>独立律师的噩梦</strong>
        记错开庭日期真是独立律师最大的噩梦了，以前在团队里的时候，同事之间还能互相照顾提醒下，独立之后但凡有点错误，哪怕是无心之失，也可能会有大麻烦。
      </div>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">现有方案的痛点</span>
      </div>

      <p>所以做好案件时间管理，对独立律师来说非常重要。市面上的普通日程提醒App，大部分都以单个事件为准，对案件待办、案件相关当事人及法官的信息没有办法统一起来，如果想整合所有信息，除了放在备忘录里面，无法做到一目了然。</p>

      <p>至于律所和人民法院在线服务网站这两个的案件管理栏目呢，如果是在律师和其他律师有合作案件的情况下，会混在一起，而且登录系统一般也比较麻烦，不登录系统就看不到相关的案件信息，并且没有办法做到离线同步提醒。</p>

      <p>综合考虑下，我倾向于选择更具有专业针对性的案件管理系统：<strong>案件云（law086.com）</strong></p>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">AI智能填充，一键添加案件</span>
      </div>

      <p>首先，该系统对比手动输入案件的普通日程管理和案件管理系统，有一大明确的优点，就是能够导入案件相关文书，进行AI信息识别，从而实现案件信息的一键添加和批量处理。</p>
      <img class="block-img" src="${requireImg('content5-1.webp')}" alt="" style="width: 100%;">

      <p>该系统在新建案件、程序信息完善、当事人录入、财产保全信息录入等多个表单中都植入了AI智能填充，可以提取关键文书信息，为律师节省大量的时间。</p>

      <div class="highlight-box">
        <strong>多格式支持</strong>
        这里的文书格式支持上传图片、Word、PDF等多种格式，准确性也比较高。
      </div>

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">案件信息一目了然</span>
      </div>

      <p>其次，该系统对于案件信息的管理非常符合J人的管理要求，对于单项法律服务到期时间，案件当事人信息、承办人信息都非常一目了然，有助于提醒律师进行客户续约、进行承办法官信息检索等。</p>

      <p>案件的进度和流程节点都会非常清楚地显示在系统中，对于单个案件还有进度视图可以展示。</p>
      <img class="block-img" src="${requireImg('content5-2.webp')}" alt="" style="width: 100%;">
      <img class="block-img" src="${requireImg('content5-3.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">04</span>
        <span class="section-title">日程同步到手机，永不遗漏</span>
      </div>

      <p>除开案件信息管理外，我觉得这个系统最切合用户实际需求的就是关于案件日程管理的设定。</p>

      <p>我在前文提到过，大部分市面上日程提醒App，对于律师的使用痛点，一是在于不能完整展示案件情况，不方便查阅；二是要单独登录系统，且提示无法同步到手机闹钟和日程提醒中，必须要在律师时刻日常注意查看时才能够起到作用。</p>

      <div class="highlight-box">
        <strong>核心功能：日程同步</strong>
        案件云管理系统一个比较特别的功能就是，在"日程"这一栏选择这个加号，可以将案件的日程信息直接同步到手机上，不用单独登录这个系统，即可获得日程提示，相当于提前给手机设置了一个"案件闹钟"，可以设置开庭前一天下午或中午，这样就不会错过任何开庭了。
      </div>
      <img class="block-img" src="${requireImg('content5-4.webp')}" alt="" style="width: 100%;">
      <img class="block-img" src="${requireImg('content5-5.webp')}" alt="" style="width: 100%;">

      <p>以上是我关于这个系统案件管理功能的使用报告，里面关于客户与线索管理、个人知识管理、案件文档管理、电子名片和团队协同管理的功能我也还在探索。</p>

      <p>值得一提的是，为了方便律师随时进行案件信息管理和更新，这个系统还有一个微信小程序可以使用，大家直接在微信搜索界面"案件云"小程序，也不用专门下载App或者单独打开浏览器进行操作了。</p>
    `,
  },
  6: {
    title: '告别繁琐协作：一套案件管理系统，让律所每个人各司其职',
    content: `
      <img class="block-img" src="${requireImg('content6-1.webp')}" alt="" style="width: 100%;">
      <p>在法律行业，效率与风险控制是永恒的主题。律师深陷于多案并行的压力，行政疲于应付流程审批，管理者难以看清全局数据——这些痛点，往往源于团队内部角色不清、工具分散、信息不通。</p>
      <p>有没有一种可能，通过一个统一的平台，让主任、律师、行政、财务乃至客户，都能在同一套规则下清晰、高效地完成自己的工作？案件云案件管理系统，正是为此而生。</p>
      <p>它不是简单的工具堆砌，而是基于对法律团队运作的深刻理解，通过精细的权限与角色设计，为每一个岗位提供量身定制的解决方案，真正实现一体化数字协作。</p>
      <img class="block-img" src="${requireImg('content6-2.webp')}" alt="" style="width: 100%;">
      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">管理者（掌握全局，把控方向）</span>
      </div>
      <img class="block-img" src="${requireImg('content6-3.webp')}" alt="" style="width: 100%;">
      <p>对于律所主任或管理合伙人而言，系统是决策的"驾驶舱"。</p>
      <p>核心场景：登录系统，首页即呈现全所实时业务全景：营收趋势、案件类型分布、律师工作量与业绩排行。无需询问，关键数据一目了然。</p>
      <p>核心操作：一键审批涉及全所规则的重大流程变更；随时查阅任何项目的关键节点，运筹帷幄。</p>
      <img class="block-img" src="${requireImg('content6-4.webp')}" alt="" style="width: 100%;">

      <p>对于行政/运营经理，系统是高效的"调度中心"。</p>
      <p>核心场景：新律师入职，迅速为其创建账号并配置好"办案"、"查阅"等权限；根据业务调整，在系统中将人员灵活划入不同团队。</p>
      <p>核心操作：统一配置全所的案件分类、文书模板和审批流程，确保工作规范有序。</p>
      <img class="block-img" src="${requireImg('content6-5.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">办案者（专注业务，高效执行）</span>
      </div>
      <img class="block-img" src="${requireImg('content6-6.webp')}" alt="" style="width: 100%;">
      <p>主办/合伙律师（案件负责人），在此是团队的"指挥官"。</p>
      <p>核心场景：在复杂的并购项目中，起草核心交易文件，并通过"@"功能将尽职调查清单分派给协办律师。随时在线审阅团队成员提交的报告，并批注意见。</p>
      <p>核心操作：把控案件所有核心文书与关键节点；在系统内分配、跟踪并审核各项任务。</p>
      <img class="block-img" src="${requireImg('content6-7.webp')}" alt="" style="width: 100%;">
      <p>协办律师及律师助理，则是前线的"执行者"。</p>
      <p>核心场景：收到主办律师@的任务提醒后，立即开展法律检索，并将整理的案例要旨上传至系统对应案件下。同步记录工作用时，自动生成清晰的工作日志。</p>
      <p>核心操作：接收并完成具体任务，提交成果；管理个人日程，确保所有截止日期无一遗漏。</p>
      <img class="block-img" src="${requireImg('content6-8.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">职能辅助人员（专业保障，流程顺畅）</span>
      </div>
      <img class="block-img" src="${requireImg('content6-9.webp')}" alt="" style="width: 100%;">
      <p>财务人员的工作与业务深度绑定，成为"业务财务官"。</p>
      <p>核心场景：在待办列表中，批量处理与案件关联的律师费用申请和报销单，点击即可核对具体案情。月末一键生成合规的财务报表和律师绩效数据。</p>
      <p>核心操作：审核所有收支凭证，确保账目清晰、可追溯；高效完成开票与统计。</p>
      <img class="block-img" src="${requireImg('content6-10.webp')}" alt="" style="width: 100%;">
      <p>风控专员（可通过自定义角色实现）是律所的"安全员"。</p>
      <p>核心场景：在新项目立项前，于系统中一键发起"利益冲突检索"，自动比对全所历史客户与案件，快速出具检索报告，将风险阻断在第一步。</p>
      <p>核心操作：执行并监督全所风险控制流程，守护执业安全底线。</p>
      <img class="block-img" src="${requireImg('content6-11.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">04</span>
        <span class="section-title">客户（信息透明，共建信任）</span>
      </div>
      <img class="block-img" src="${requireImg('content6-12.webp')}" alt="" style="width: 100%;">
      <p>客户联系人（如公司法务）被纳入协作流程，成为透明的"参与者"。</p>
      <p>核心场景：通过微信小程序安全登录，随时查看授权案件的当前阶段、最新文书，并在专属沟通区留言确认，免去反复电话邮件的低效沟通。</p>
      <p>核心操作：查阅进度、下载文件、在线反馈，体验高效、尊重的法律服务过程。</p>
      <img class="block-img" src="${requireImg('content6-13.webp')}" alt="" style="width: 100%;">
      <p>一体化，才是真效率</p>
      <p>真正的效率提升，并非让个人更快，而是让团队协同更流畅。案件云通过精准的权限映射，让管理者能"管得好"，让办案者能"专心办"，让支持者能"高效辅"，让客户能"放心看"。它让权责清晰可见，让信息在安全轨道上自由流动，最终将整个律所的运营，凝聚成一个目标一致、行动高效的数字化整体。</p>
      <p>选择案件云，就是选择为您的团队构建一套权责清晰、无缝协作的现代工作模式。</p>
    `,
  },
  7: {
    title: '当用户问："你们产品，是不是有律师参与？',
    content: `
      <img class="block-img" src="${requireImg('content7-1.webp')}" alt="" style="width: 100%;">
      <p>"你们产品开发一定有律师参与吧？"</p>

      <p>经常有用户这样问我们，每当听到这些留言，我们都倍感荣幸。用户每一次真诚的肯定都是对案件云产品最高的褒奖。</p>

      <p>确实，市面上的管理工具千千万，但很多律师用起来总觉得隔靴搔痒：要么是功能太泛，无法适配诉讼的复杂流程；要么是设计太硬，不懂法律人对风险的深层焦虑。</p>

      <p>而案件云之所以被评价为一定有法律背景，是因为它的底层代码里，不仅写着技术，更刻着法律人的DNA。</p>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">它懂你的焦虑：不是提醒，是风控</span>
      </div>

      <p>对于律师而言，错过一个普通会议可以重约，但错过一个保全续封期限，可能面临的就是执业生涯的滑铁卢。</p>

      <p>通用工具只能做到日程提醒，而案件云设计了专门的保全续封清单。</p>

      <ul>
        <li><strong>懂痛点：</strong>它知道你最怕遗漏，所以它自动同步所有案件保全信息，按到期日由近及远排列。</li>
        <img class="block-img" src="${requireImg('content7-2.webp')}" alt="" style="width: 100%;">
        <li><strong>懂节奏：</strong>它不仅是弹个窗，而是通过微信、App、桌面多路追杀式提醒。</li>
        <img class="block-img" src="${requireImg('content7-3.webp')}" alt="" style="width: 100%;">
        <li><strong>懂规矩：</strong>在立案前，进行利益冲突检索与多重查重（案件、客户、项目），把风险扼杀在收案之前。</li>
        <img class="block-img" src="${requireImg('content7-4.png')}" alt="" style="width: 100%;">
      </ul>

      <p>这种设计，不是为了打卡，而是为了帮律师守住执业的底线。</p>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">它懂你的连贯：是程序，不是碎片</span>
      </div>

      <p>法律人的工作不是切香肠，而是一场连续剧。从一审、二审到执行，案情是流动的，证据是沿用的。</p>

      <p>很多软件让律师痛苦的地方在于：每到一新程序，就要重新建档，数据是割裂的。案件云则还原了诉讼程序链条：</p>

      <ul>
        <li><strong>无缝切换：</strong>在一个案件下，你可以快速创建关联的二审或执行案件，案情数据终身复用，无需重复录入。</li>
        <img class="block-img" src="${requireImg('content7-5.webp')}" alt="" style="width: 100%;">
        <li><strong>解放双手：</strong>它内置了76类民事案件的要素式文书。输入核心要素，AI一键生成起诉状、答辩状，甚至能批量生成全套立案材料。除了文书模板，最新的AI文书起草功能可自由起草你需要的各类文书。</li>
        <img class="block-img" src="${requireImg('content7-6.webp')}" alt="" style="width: 100%;">
      </ul>

      <p>它把律师从复制粘贴的机械劳动中解放出来，让你把智慧留给复杂的法律研判。</p>

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">它懂你的钱袋子：算得清账，才分得好钱</span>
      </div>

      <p>律所的财务逻辑，恐怕是世界上最复杂的算术题之一。</p>

      <p>通用财务软件无法理解什么是主理律师提成，什么是案源人管理费。而案件云的一案一本账功能，简直像是为律师量身定制的会计：</p>

      <ul>
        <li><strong>精细分配：</strong>每一笔回款，都能直接设定主办、协办、助理的分配比例。</li>
        <img class="block-img" src="${requireImg('content7-7.webp')}" alt="" style="width: 100%;">
        <li><strong>清晰溯源：</strong>无论是固定金额还是百分比，系统自动记录，谁该拿多少，哪天拿的，一目了然。</li>
        <img class="block-img" src="${requireImg('content7-8.webp')}" alt="" style="width: 100%;">
      </ul>

      <p>此外，它还把LPR利息计算、工伤赔偿、诉讼费计算等刚需工具直接内嵌在办案流程中，不用再去百度找计算器，真正做到了手边即用。</p>
      <img class="block-img" src="${requireImg('content7-9.webp')}" alt="" style="width: 100%;">

      <div class="section-header">
        <span class="section-num">04</span>
        <span class="section-title">它懂你的体面：专业，是被看见的细节</span>
      </div>

      <p>律师的专业度，往往体现在交付给客户的那一刻。</p>

      <p>当客户询问案件进展时，你不需要再翻找聊天记录、拼凑文档。案件云支持一键生成案件查阅报告。</p>

      <ul>
        <li><strong>结构化展示：</strong>自动整合办案策略、进展明细、工作记录。</li>
        <img class="block-img" src="${requireImg('content7-10.webp')}" alt="" style="width: 100%;">
        <li><strong>便捷交付：</strong>生成专属链接或二维码，发给客户。</li>
        <img class="block-img" src="${requireImg('content7-11.webp')}" alt="" style="width: 100%;">
      </ul>

      <p>这种秒回且精致的反馈，让客户直观感受到：我的律师，真的很专业。</p>

      <p>回到开头那位用户的问题。</p>

      <p>是的，案件云的核心团队正是由法律+技术的复合型人才组成。</p>

      <p>正如用户所言，它不仅仅是一个工具，它是法律人的云端数字化大脑。它深度融入了律师的办案逻辑、工作节奏与风险防控需求，像一位并肩作战的战友，帮你挡住风险，理清繁杂，让你在法律的战场上，赢得更漂亮。</p>
      <img class="block-img" src="${requireImg('content7-12.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>案件云，比自己更懂你的办案习惯。</strong>
      </div>
    `,
  },
  8: {
    title: '2026律所案件管理系统推荐，谁才是中国律所的数字化"最优解"？',
    content: `
      <p>在法律行业从"经验驱动"向"数据驱动"转型的今天，一家律所的核心竞争力已不仅仅取决于大律师的个人能力，更取决于律所整体的组织效率与协作水平。</p>

      <p>对于管理者而言，如何从繁杂的事务中解放人力？如何规避执业风险？如何让财务数据清晰透明？这一切问题的答案，都指向了一个核心决策——选择一款真正合适的<b>律所案件管理系统</b>。这不仅是工具的升级，更是<b>律所管理</b>模式的革新。</p>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">破局之道：为什么选择一款合适的"律所案件管理系统"如此重要？</span>
      </div>

      <p>在传统的<b>律所管理</b>模式中，案件卷宗堆积如山、进度靠口头询问、财务靠手工制表，这导致了效率低下与风控缺失。引入一款专业的<b>律所案件管理系统</b>，将从以下四个维度从根本上重塑律所的运营基因：</p>

      <ul>
        <li><strong>重塑协作效率，打破信息孤岛</strong> 合适的系统能将分散在个人手中的案件信息、文档和进度统一汇聚。团队成员不再需要反复沟通确认"案子到了哪一步"，而是通过系统的协同办案功能，实时共享进度与文档，实现"1+1>3"的协作效应。</li>
        <li><strong>筑牢风控防线，规避执业风险</strong> 风险控制是<b>律所管理</b>的生命线。优秀的系统能在立案阶段自动进行利益冲突检索，防止违规代理；在办案过程中，通过智能日程提醒，确保每一个诉讼时效和关键节点不被遗漏。</li>
        <li><strong>沉淀知识资产，实现可持续发展</strong> 律师的流失往往意味着经验和客户的流失。通过系统化的知识库管理，律所可以将案件文档、法律文书模板沉淀为机构资产，通过复用过往经验，提升整体办案质量，不因人员变动而通过降低服务水准。</li>
        <li><strong>数据驱动决策，优化财务健康</strong> 从粗放式记账转向精细化核算。系统能自动汇总每一笔案件的收支情况，让管理者清晰看到哪个团队创收最高、哪类案件成本最低，为律所的战略发展提供精准的数据支撑。</li>
      </ul>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">巅峰对决：Clio、MyCase 与 案件云，谁更懂中国律所管理？</span>
      </div>

      <p>明确了重要性后，我们选取了国际知名的 Clio、MyCase 与国内领先的 <b>案件云</b> 进行横向对比。在功能维度上，三者各有千秋，但针对中国律所的具体应用场景，差异显著。</p>

      <p><strong>1. 移动协作与生态连接：连接力的比拼</strong></p>

      <ul>
        <li><strong>Clio / MyCase：</strong> 依然沿用传统的"邮件+独立APP"模式，对于习惯在微信上沟通工作的中国律师来说，信息流转存在断层。</li>
        <li><strong>案件云：</strong> 深度集成了微信生态。它不仅拥有Web端和APP，更开发了<b>微信小程序</b>。律师无需下载安装，在微信中即可一键登录，接收案件提醒、上传文件，真正实现了与客户、团队的无缝连接。此外，其"电子名片"功能支持一键转发，更符合国内的商务社交习惯。</li>
      </ul>

      <p><strong>2. 智能化应用：AI 实战能力的较量</strong></p>

      <ul>
        <li><strong>Clio / MyCase：</strong> AI 功能多集中在基础检索，且对中文法律语境的理解存在天然壁垒。</li>
        <li><strong>案件云：</strong> 将 AI 深度融入了<b>律所案件管理系统</b>的日常。
          <br><b>• AI 合同审查：</b> 全流程 AI 驱动，一键生成审查清单，自动识别风险条款并双向定位溯源，支持甲/乙方/中性立场切换。
          <br><b>• 智能文书生成：</b> 支持 76 类民事案件起诉状、答辩状的 AI 生成。
          <br><b>• 数字分身：</b> 提供 7x24 小时 AI 法律顾问，辅助案源转化。
        </li>
      </ul>

      <p><strong>3. 财务与行政风控：本土化管理的深度</strong></p>

      <ul>
        <li><strong>Clio / MyCase：</strong> 基于西方的时薪制和通用的财务逻辑，难以应对中国复杂的增值税发票与行政审批流程。</li>
        <li><strong>案件云：</strong> 专为中国<b>律所管理</b>痛点设计。
          <br><b>• 行政审批：</b> 针对律所盖章难、异地签署慢的问题，提供电子签章与用印审批功能，全程留痕且接入公安系统验证。
          <br><b>• 财务合规：</b> 支持在线开票申请、报销审批、律师费计算等功能，每一笔收支都精确关联到具体案件，实现财务业务一体化。
        </li>
      </ul>

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">最终推荐：案件云——重新定义高效的律所案件管理系统</span>
      </div>

      <p>综上所述，当我们在寻找一款能够切实提升<b>律所管理</b>效能的工具时，<b>案件云</b>凭借其对本土法律业务的深刻理解，成为了优于国际竞品的最佳选择。</p>

      <div class="highlight-box">
        <strong>推荐理由：</strong>
        <p style="margin-bottom: 10px;"><strong>1. 全流程闭环管理：</strong> 从线索跟进、立案冲突检索，到办案协作、文档归档，再到财务结算、发票开具，案件云覆盖了律所业务的全生命周期。</p>
        <p style="margin-bottom: 10px;"><strong>2. 极致的易用性：</strong> 依托微信小程序，极大地降低了律师的学习成本和使用门槛，让系统不再是摆设，而是真正高频使用的生产力工具。</p>
        <p><strong>3. 强大的 AI 赋能：</strong> 通过 AI 合同智审和数字分身，切实帮助律师减少重复劳动，提升专业交付能力。</p>
      </div>

      <div class="highlight-box">
        <strong>结论</strong>
        选择一款<b>律所案件管理系统</b>，本质上是在选择律所未来的工作方式。<b>案件云</b>以其"更懂中国律师"的产品逻辑，成功帮助 400 多家律所和 20000 多名律师实现了数字化升级。如果您致力于打造一家高效、合规、智能的现代化律所，<b>案件云</b>无疑是您当下的不二之选。
      </div>
    `,
  },
  9: {
    title: '一份优秀的案件报告应该怎么写？',
    content: `
      <p>在律师的日常工作中，办案和汇报往往同样重要。很多律师有过这样的困扰：明明自己在案件上投入了大量精力，做了很多隐形的工作，但当事人因为看不到过程，总觉得律师"没干活"。</p>

      <p>一份高质量的案件报告，不仅是向客户展示工作成果的"成绩单"，更是管理客户预期、建立信任感的关键工具。</p>

      <div class="section-header">
        <span class="section-num">01</span>
        <span class="section-title">优秀案件报告的三个核心要素</span>
      </div>

      <p><strong>1. 拒绝流水账，结构要清晰</strong></p>
      <p>很多律师习惯把所有做过的事情按时间顺序列出来，像记流水账一样。其实，当事人更关心的是"结果"和"现状"。</p>
      <p>一个好的结构建议是："当前进展总述 + 关键节点回顾 + 下一步工作计划"</p>

      <ul>
        <li><strong>当前进展总述：</strong>先用一句话告诉客户案件现在到了哪个阶段（如：已立案，等待排期）。</li>
        <li><strong>关键节点回顾：</strong>再列出近期完成的核心工作（如：已完成证据整理，已提交保全申请）。</li>
        <li><strong>下一步工作计划：</strong>最后明确告知客户接下来需要配合什么，或者预计什么时候会有新动向。</li>
      </ul>

      <p><strong>2. 及时性</strong></p>
      <p>案件报告不是结案陈词，而是过程中的定心丸。定期的（如每月或每个关键节点）汇报，能有效缓解客户的焦虑。</p>

      <div class="section-header">
        <span class="section-num">02</span>
        <span class="section-title">痛点：写报告太耗时怎么办？</span>
      </div>

      <p>道理大家都懂，但现实是残酷的。</p>
      <p>律师的时间极其宝贵，光是整理卷宗、起草文书就已经焦头烂额。如果每个案件都要手动去翻找聊天记录、核对财务数据、梳理日程，再排版打印，写一份报告可能要花掉半天时间。</p>

      <p>有没有一种方法，既能保持报告的专业度，又能把写报告的时间从"小时级"压缩到"分钟级"？</p>

      <div class="section-header">
        <span class="section-num">03</span>
        <span class="section-title">案件云：一键生成案件报告</span>
      </div>

      <p><strong>让专业"看得见"</strong></p>
      <p>作为专为法律人打造的数字化协作平台，案件云深知律师痛点，特别推出了"案件报告"功能（个人高阶版、团队版、律所版专属功能），帮助你从繁琐的整理工作中解脱出来。</p>

      <div class="highlight-box">
        <strong>核心价值：为什么需要它？</strong>
        <strong>✅ 节省汇报时间</strong> 无需手动整理办案记录和工作日志，系统自动抓取案件数据生成报告，将数小时的整理工作缩短为几分钟。<br>
        <strong>✅ 提升专业形象</strong> 生成的报告界面美观、结构清晰，客户可以直接在手机微信上查看，体现律师服务的可视化和透明化。<br>
        <strong>✅ 服务价值外化</strong> 通过展示详细的"事件办理明细"，让客户直观看到律师在案件背后付出的工时和努力，减少客户对律师费的质疑。
      </div>
      <img class="block-img" src="${requireImg('content9-1.webp')}" alt="" style="width: 100%;">

      <p><strong>报告包含哪些内容？</strong></p>
      <p>案件报告的内容非常丰富，且支持自定义编辑。默认模块通常包括：</p>

      <ul>
        <li><strong>案件进展：</strong>当前的诉讼阶段和最新动态。</li>
        <li><strong>办案策略：</strong>律师对案件的分析和下一步计划。</li>
        <li><strong>事件办理明细：</strong>详细列出每一次开庭、会见、起草文书等工作记录及耗时。</li>
        <li><strong>其他：</strong>如所需协助、财产线索、执行情况、律师简介等。</li>
      </ul>
      <img class="block-img" src="${requireImg('content9-2.webp')}" alt="" style="width: 100%;">

      <p><strong>功能亮点与操作</strong></p>

      <p><strong>高度可配置（编辑与隐藏）</strong></p>
      <p>生成的报告并非千篇一律。在PC端生成报告后，您可以点击"编辑"，对各个模块进行修改。如果您不希望客户看到某些敏感信息（如具体的办案策略或内部备注），可以直接隐藏相应模块，随心调整报告内容。</p>

      <p><strong>一键生成与预览</strong></p>
      <p>在案件详情页点击"生成报告"按钮，系统即刻生成。编辑完成后点击"保存并预览"即可看到最终效果。</p>

      <p><strong>安全的分享机制</strong></p>
      <ul>
        <li><strong>链接分享：</strong>生成一个专属链接发送给客户。</li>
        <li><strong>支持导出：</strong>除了在线分享，也支持将报告导出为图片保存，方便打印或归档。</li>
      </ul>

      <p><strong>客户如何查看？</strong></p>
      <p>无需下载APP，只需通过您分享的链接，即可在手机浏览器或微信中实时查看案件的最新进展报告。</p>
      <img class="block-img" src="${requireImg('content9-3.webp')}" alt="" style="width: 100%;">

      <div class="highlight-box">
        <strong>总结</strong>
        案件报告功能是连接律师与客户的桥梁，它通过"过程留痕+自动生成+移动端展示"，帮助律师轻松完成案件汇报，增强客户信任感。
      </div>
    `,
  },
}

export default {
  name: 'ContentDetail',
  components: {
    Footer,
  },
  data() {
    return {
      currentContent: null,
    }
  },
  watch: {
    '$route.query.id': {
      handler(newVal) {
        this.loadContent(newVal)
      },
      immediate: true,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Content' })
    },
    loadContent(id) {
      const contentId = parseInt(id) || 1
      this.currentContent = contentData[contentId] || contentData[1]
    },
  },
}
</script>

<style lang="stylus" scoped>
.content-detail-wrap {
  min-height: 100vh;
  background: #f7f6fb;
}

.nav-bar {
  padding: 20px 36px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  font-size: 28px;
  font-weight: 500;
  color: #303443;
  cursor: pointer;
  padding: 16px 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid rgba(0, 0, 0, 0.04);

  &:active {
    transform: scale(0.96);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  svg {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateX(-4px);
  }
}

.detail-container {
  padding: 40px 36px 60px;
}

.detail-title {
  font-size: 44px;
  font-weight: bold;
  color: #303443;
  line-height: 64px;
  margin-bottom: 24px;
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 12px;
    width: 6px;
    height: 40px;
    background: #FFC000;
    border-radius: 3px;
  }
}

.detail-meta {
  font-size: 26px;
  font-weight: 500;
  color: #5D5F6A;
  line-height: 40px;
  margin-bottom: 40px;
  padding-left: 20px;

  span {
    display: block;
    margin-bottom: 8px;
  }
}

.detail-content {
  font-size: 30px;
  line-height: 50px;
  color: #5D5F6A;

  >>> p {
    margin-bottom: 24px;
    text-align: justify;
  }

  >>> strong, >>> b {
    color: #303443;
    font-weight: 600;
  }

  >>> .section-header {
    display: flex;
    align-items: center;
    margin: 50px 0 30px;
  }

  >>> .section-num {
    font-size: 56px;
    font-weight: 800;
    color: #FFC000;
    margin-right: 16px;
    line-height: 1;
  }

  >>> .section-title {
    font-size: 36px;
    font-weight: bold;
    color: #303443;
    line-height: 50px;
  }

  >>> ul {
    list-style: none;
    padding: 30px;
    margin: 30px 0;
    background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
    border-radius: 16px;
    border-left: 4px solid #6283FF;

    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 20px;
      font-size: 28px;
      line-height: 44px;
      color: #5D5F6A;

      &:last-child {
        margin-bottom: 0;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 16px;
        width: 12px;
        height: 12px;
        background: #6283FF;
        border-radius: 50%;
      }

      strong {
        color: #303443;
        font-weight: 600;
      }

      img {
        display: block;
        width: 100%;
        margin: 20px 0;
      }
    }
  }

  >>> .highlight-box {
    background: linear-gradient(135deg, rgba(98, 131, 255, 0.08) 0%, rgba(98, 131, 255, 0.03) 100%);
    border-radius: 16px;
    padding: 30px;
    margin: 30px 0;
    border-left: 4px solid #6283FF;

    strong {
      display: block;
      font-size: 32px;
      font-weight: 600;
      color: #303443;
      line-height: 48px;
      margin-bottom: 16px;
    }

    p {
      font-size: 28px;
      line-height: 44px;
      margin-bottom: 12px;
    }
  }

  >>> img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    margin: 30px 0;
    display: block;

    &.block-img {
      margin: 30px auto;
    }
  }
}
</style>
